<div nz-col class="bg-white px-4 rounded-xl shadow-sm">
  <div nz-row style="padding: 15px">
    <form nz-form [formGroup]="dateform" class="ant-advanced-search-form">
      <div nz-row [nzGutter]="[10, 10]">
        <div nz-col [nzSpan]="4">
          <nz-range-picker
            [nzRanges]="ranges"
            [(ngModel)]="date"
            [ngModelOptions]="{ standalone: true }"
            nz-col
            nzFlex="0 1 300px"
            [nzFormat]="dateFormat"
            [nzPlaceHolder]="['statistic.detailSearch.search.start' | translate, 'statistic.detailSearch.search.finish' | translate]"
            (ngModelChange)="changeCalendar($event)"
          ></nz-range-picker>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            formControlName="employeeId"
            [data]="employees"
            placeholder="{{'statistic.detailSearch.search.employee' | translate}}"
            valueMember="id"
            displayMember="fullName"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select-search
            formControlName="userId"
            [data]="customers"
            placeholder="{{'statistic.detailSearch.search.user' | translate}}"
            (onSearch)="searchCustomer($event)"
            valueMember="id"
            displayMember="fullName"
          ></beautyapp-select-search>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            formControlName="serviceCategoryId"
            placeholder="{{'statistic.detailSearch.search.procedureCategory' | translate}}"
            valueMember="id"
            displayMember="name"
            [data]="serviceCategories"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            formControlName="serviceId"
            placeholder="{{'statistic.detailSearch.search.procedure' | translate}}"
            valueMember="id"
            displayMember="name"
            [data]="services"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            placeholder="{{'statistic.detailSearch.search.expenseCategory' | translate}}"
            formControlName="expenceMainCategoryId"
            [data]="expenceCategories"
            valueMember="id"
            displayMember="name"
            (selected)="getChildExpense($event)"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            placeholder="{{'statistic.detailSearch.search.expenseSubCategory' | translate}}"
            formControlName="expenceCategoryId"
            [data]="expenceSubCategories"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            placeholder="{{'statistic.detailSearch.search.sourceOperation' | translate}}"
            formControlName="operationSource"
            [data]="operationSource"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            placeholder="{{'statistic.detailSearch.search.operationType' | translate}}"
            formControlName="operationType"
            [data]="operationType"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select>
        </div>
        <beautyapp-select
          nz-col [nzSpan]="4"
          placeholder="{{
            'statistic.transaction.search.paymentMethod' | translate
          }}"
          formControlName="paymentType"
          [data]="paymentTypes"
          valueMember="id"
          displayMember="name"
        ></beautyapp-select>
        <div nz-col [nzSpan]="4">
          <beautyapp-input
            formControlName="productCodeOrBarcode"
            placeholder="{{'statistic.detailSearch.search.productCodeBarcode' | translate}}"
          ></beautyapp-input>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select-search
            formControlName="productId"
            [data]="products"
            placeholder="{{'statistic.detailSearch.search.product' | translate}}"
            (onSearch)="searchProduct($event)"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select-search>
        </div>
        <div nz-col [nzSpan]="4">
          <beautyapp-select
            formControlName="productCategoryId"
            [data]="productCategories"
            placeholder="{{'statistic.detailSearch.search.productCategory' | translate}}"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select>
        </div>

        <div nz-col [nzSpan]="4">
          <beautyapp-select
            formControlName="distributorId"
            [data]="distributors"
            placeholder="{{'statistic.detailSearch.search.productProvider' | translate}}"
            valueMember="id"
            displayMember="name"
          ></beautyapp-select>
        </div>
        <div nz-col [nzSpan]="4">
          <label nz-checkbox formControlName="isVatIncluded">
            დღგ-ით დასაბეგრი
          </label>
        </div>
        <div nz-col [nzSpan]="4" class="search-area">
          <nz-space>
            <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
              <button
                *nzSpaceItem
                type="button"
                nz-button
                nzType="default"
                nzShape="circle"
                nz-tooltip
                nzTooltipTitle="{{'buttons.download' | translate}}"
                (click)="export()"
                >
                <i nz-icon nzType="file-excel" nzTheme="outline"></i>
              </button>
            </ng-template>
            <button
              *nzSpaceItem
              type="button"
              nz-button
              nzType="primary"
              (click)="search()"
              >
              {{'buttons.search' | translate}}
            </button>
            <button
              *nzSpaceItem
              type="button"
              nz-button
              (click)="clearSearch()"
              >
              {{'buttons.clear' | translate}}
            </button>
          </nz-space>
        </div>
        <!--        <div nz-col [nzSpan]="4" *ngFor="let control of controlArray" [hidden]="!control.show">-->
        <!--          <beautyapp-input [formControlName]="'field' + control.index"  placeholder="placeholder" ></beautyapp-input>-->
      <!--        </div>-->
    </div>
  </form>
</div>
<div class="table-content">
  <nz-table
    nzBordered
    nzShowSizeChanger
    [nzData]="loadData"
    [nzFrontPagination]="false"
    [nzLoading]="loading"
    [nzTotal]="total"
    [nzPageSize]="paginatorPageSize"
    [nzPageIndex]="paginatorPageIndex"
    [nzVirtualForTrackBy]="trackByIndex"
    (nzQueryParams)="paginatorChange($event)"
    [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
    nzTableLayout="auto"
    [nzScroll]="{ x: '84vw' }"
    nzSize="small"
    >
    <thead>
      <tr>
        <th nzWidth="40px" nzLeft></th>
        <th nzWidth="80px">{{ 'statistic.detailSearch.column.operationNumber' | translate }}</th>
        <th nzWidth="100px" nzLeft>{{ 'statistic.detailSearch.column.date' | translate }}</th>
        <th nzWidth="180px" nzLeft>{{ 'statistic.detailSearch.column.sourceOperation' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.type' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.paymentMethod' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.service' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.category' | translate }}</th>
        <th nzWidth="80px">{{ 'statistic.detailSearch.column.time' | translate }}</th>
        <th nzWidth="220px">{{ 'statistic.detailSearch.column.user' | translate }}</th>
        <th nzWidth="110px">{{ 'statistic.detailSearch.column.price' | translate }}</th>
        <!--          <th>{{'COLUMNS.cash' | translate}}</th>-->
        <!--          <th>{{'COLUMNS.card' | translate}}</th>-->
        <!--          <th>{{'COLUMNS.bankTransfer' | translate}}</th>-->
        <th nzWidth="170px">{{ 'statistic.detailSearch.column.discountPrice' | translate }}</th>
        <th nzWidth="170px">{{ 'statistic.detailSearch.column.discount%' | translate }}</th>
        <th nzWidth="170px">{{ 'statistic.detailSearch.column.fixatedExpense' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.specialProcedureExpense' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.employee' | translate }}</th>
        <th nzWidth="100px">{{ 'statistic.detailSearch.column.employeeSalary' | translate }}</th>
        <th nzWidth="80px">დღგ</th>
        <th nzWidth="100px">დღგ თანხა</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.expenseCategory' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.nameProduct' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.barcode' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.category' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.provider' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.quantity' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.capacity' | translate }}</th>
        <th nzWidth="180px">{{ 'statistic.detailSearch.column.created' | translate }}</th>
        <th nzWidth="200px">{{ 'statistic.detailSearch.column.createdBy' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (row of loadData; track row; let i = $index) {
        <tr>
          <td nzLeft>
            <button
              (click)="view(row?.operation)"
              nz-button
              nzType="primary"
              nzSize="small"
              nzShape="circle"
              >
              <i nz-icon nzType="eye"></i>
            </button>
          </td>
          <td>{{ row?.id }}</td>
          <td nzLeft>{{ row?.operationDate | date: 'dd/MM/yyyy' }}</td>
          <td nzLeft>
            {{
            'OPERATION_SOURCE.' + row?.operation?.operationSource | translate
            }}
            @if (row?.isGift) {
              <i nz-icon nzType="gift" nzTheme="outline"></i>
            }
            @if (row?.description) {
              <i
                nz-icon
                nzType="comment"
                nzTheme="outline"
                [nz-tooltip]="row?.description"
              ></i>
            }
          </td>
          <td>
            {{ 'OPERATION_TYPE.' + row?.operationType | translate }}
            @if (row.isGift) {
              <i nz-icon nzType="gift" nzTheme="outline"></i>
            }
          </td>
          <td>
            {{ row?.operation?.paymentType | paymentType | translate }}
          </td>
          <td nzEllipsis [nz-tooltip]="row?.service?.name">
            {{ row?.service?.name }}
            @if (row?.packagePurchaseId) {
              <nz-tag nzColor="cyan" style="font-size: 10px;">პაკეტი</nz-tag>
            }
          </td>
          <td nzEllipsis [nz-tooltip]="row?.serviceCategory?.name">{{ row?.serviceCategory?.name }}</td>
          <td>{{ row?.time }}</td>
          <td>
            @if (row?.user) {
              <nz-tag (click)="viewUser(row?.user)" style="cursor: pointer">
                {{ row.user.fullName }}
                <span nz-icon nzType="link" nzTheme="outline"></span>
              </nz-tag>
            }
          </td>
          <td>
            {{ row?.price }}
          </td>
          <!--          <td>{{row?.cash}}</td>-->
          <!--          <td>{{row?.card}}</td>-->
          <!--          <td>{{row?.bankTransferPrice}}</td>-->
          <td>{{ row?.salePrice }}</td>
          <td>{{ row?.salePercent }}</td>
          <td>{{ row?.fixedSpend }}</td>
          <td>{{ row?.specFixedSpend }}</td>
          <td>{{ row?.employee ? row?.employee?.user?.fullName : '' }}</td>
          <td>{{ row?.employeeSalary }}</td>
          <td>
            @if (row?.isVatIncluded) {
              <span nz-icon nzType="check" nzTheme="outline" style="color: green;"></span>
            }
          </td>
          <td>
            @if (row?.isVatIncluded) {
              {{ row?.vatAmount | number:'1.0-2' }}
            }
          </td>
          <td nzEllipsis nz-tooltip="{{ row?.expenceMainCategory?.name }} / {{ row?.expenceCategory?.name }}">
            {{ row?.expenceMainCategory?.name }} /
            {{ row?.expenceCategory?.name }}
          </td>
          <td nzEllipsis [nz-tooltip]="row?.product?.name">{{ row?.product?.name }}</td>
          <td>{{ row?.barcode }} / {{ row?.productCode }}</td>
          <td nzEllipsis [nz-tooltip]="row?.productCategory?.name">{{ row?.productCategory?.name }}</td>
          <td nzEllipsis [nz-tooltip]="row?.distributor?.name">{{ row?.distributor?.name }}</td>
          <td>{{ row?.quantity || row?.unitQuantity }}</td>
          <td>{{ row?.unitGram }}</td>
          <td>{{ row?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ row?.operation?.createdBy?.fullName || '—' }}</td>
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td colspan="17"></td>
        <td></td>
        <td>
          @if (totalVat) {
            {{ totalVat | number:'1.0-2' }}
          }
        </td>
        <td colspan="9"></td>
      </tr>
    </tfoot>
  </nz-table>
</div>
</div>
